import './modal-categories-details.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import ModalTemplate from '../modal-template/modal-template';
import TranslateService from '../../services/translate-service';
import { ASSETS } from '../../constants';

export default function ModalCategoriesDetails(props) {


    return (
        <ModalTemplate isOpen={props.isOpen} className='modal-categories-details' >
            <div className='flex items-center mb-8'>
                <div className='heading-h6 grow uppercase'>{TranslateService.get('stats.modal.categories.title')}</div>
                <div>
                    <button className='btn-close ' onClick={props.onClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
            </div>

            <div className='max-height'>
                {
                    props.categories.map(c => (
                        <div className='flex items-center mb-7' key={c.categoria._id}>
                            <div className='rounded-full avatar-pink'>
                                <img src={ `${ASSETS.ICONS_CATEGORIES}${c.categoria.icono}`} alt='' className='rounded-full m-auto w-[48px]' />
                            </div>

                            <div className='ml-5'>
                                <h6 className='heading-h6'>{c.categoria.nombre}</h6>
                                <p className='text-secundary'>{TranslateService.get('stats.modal.categories.questions')}: {c.correctas + c.incorrectas}</p>
                                <p className='text-secundary my-1'><span>✅ {c.correctas}</span> <span className='ml-6'>❌ {c.incorrectas}</span></p>
                                <p className='text-secundary'>{TranslateService.get('stats.modal.categories.accuracy')}: {c.precision}%</p>
                            </div>
                        </div>
                    ))
                }


            </div>

        </ModalTemplate>
    )
}